export const isAlipayCommodityCode = (commodityCode) => {
  const commodityCodes = [
    "54ef0199-eb74-44d9-8d85-7ac7eb61fda6",
  ];

  return commodityCodes.includes(commodityCode);
};
